import React, { useState, useEffect, useContext } from "react";
import {
  Grid,
  Select,
  MenuItem,
  IconButton,
  Typography,
  Paper,
  FormControl,
  InputLabel,
  Tooltip,
  OutlinedInput,
  InputAdornment,
  Container,
  TextField,
  Box,
} from "@material-ui/core";
import {
  Settings as SettingsIcon,
  Clear as ClearIcon,
  MailOutline as MailOutlineIcon,
} from "@material-ui/icons";

import AppContext from "../../components/appContext";

import { DateTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import rest from "../../rest";
import frLocale from "date-fns/locale/fr";
import FilteredSelect from "./filteredData";
import "./contactbenevole.css";
import CustomEditorDropdown from "./CustomEditorDropdown";
import { useModal } from "../../components/general/modalContext";
import ModelCourierModifiable from "./modelCourierModifiable";
import HistoriqueTable from "./historiqueMail";
import { MySnackbar } from "../../components/mySnackbar/MySnackbar";
import { useSelector } from "react-redux";
import { stDateTimeFromDate } from "../../components/general/formateDate";
import SchedulerTable from "../../components/contactBenevoles/table/SchedulerTable";
import { themeColors } from "../../components/css/themeConfig";
import { makeStyles } from "@material-ui/core/styles";
import GroupSelect from "./GroupSelect";
import ConfirmationModal from "../../components/contactBenevoles/modal/ConfirmationModal";
import LoadingIndicator from "../../components/loadingIndicator/LoadingIndicator";
import ButtonStyled from "../../components/general/ButtonStyled";

import ShareIcon from "@material-ui/icons/Share";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

const useStyles = makeStyles((theme) => ({
  headerContainer: {
    padding: theme.spacing(2),
    backgroundColor: (props) => themeColors[props.themeName].headerColor,
    display: "flex",
    alignItems: "center",
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
  },
  headerIcon: {
    color: (props) => themeColors[props.themeName].color,
    marginRight: theme.spacing(1),
  },
  headerText: {
    color: (props) => themeColors[props.themeName].color,
  },
  primaryButton: {
    backgroundColor: (props) => themeColors[props.themeName].headerColor,
    color: (props) => themeColors[props.themeName].color,
  },
}));

const FormContactBene = () => {
  const [aValue, setAValue] = useState([]);
  const [modeleValue, setModeleValue] = useState(0);
  const [modeleData, setModeleData] = useState([]);
  const [destinataireValue, setDestinataireValue] = useState([]);
  const [message, setMessage] = useState("");
  const [includeExclude, setIncludeExclude] = useState("include");
  const [groupesDestinataires, setGroupesDestinataires] = useState([]);
  const [destinataires, setDestinataires] = useState([]);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedDestByGroups, setSelectedDestByGroups] = useState([]);
  const { openModal, closeModal } = useModal();
  const [snack, setSnack] = useState({});
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const currentUser = useSelector((state) => state.user);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const myContext = useContext(AppContext);
  const openSidebar = myContext.openSidebar;
  const [listGroupeDestinataireText, setListeGroupeDestinataireText] = useState(
    []
  );

  const [error, setError] = useState("");

  const themeName =
    useSelector((state) => state.manif?.manifParams?.Theme) || "theme1";

  const manifEmail = useSelector(
    (state) => state.manif?.manifInfos?.Default_Email
  );
  const userEmail = useSelector((state) => state.user?.Person?.Person_Email);

  const [repondreA, setRepondreA] = useState(manifEmail);

  const classes = useStyles({ themeName });

  useEffect(() => {
    // Récupération des données pour les groupes de destinataires
    rest
      .post("/benevols/listedestinataireGlobal.json")
      .then((response) => {
        setGroupesDestinataires(response.data);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération des groupes de destinataires :",
          error
        );
      });

    // Récupération des données pour les destinataires
    rest
      .post("/benevols/listedestinatairePersonne.json")
      .then((response) => {
        setDestinataires(response.data);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération des destinataires :",
          error
        );
      });

    // Récupération de l'historique

    // Récupération de l'historique
  }, []);

  // Récupération des modèles de courrier
  useEffect(() => {
    setLoading(true);
    rest
      .post("/benevols/modelescouriers.json")
      .then((response) => {
        setModeleData(response.data?.Modeles);
        setLoading(false);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération des Modeles :",
          error
        );
        setLoading(false);
      });
  }, [refresh]);

  // Récupération des destinataires par groupe
  useEffect(() => {
    setLoading(true);
    const params = {
      vDest: aValue.join(","),
      includeExclude: includeExclude,
    };
    rest
      .post("/email/lstNomsDestinataire", params)
      .then((response) => {
        setSelectedDestByGroups(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error(
          "Une erreur s'est produite lors de la récupération des destinataire de handleGroupeChange :",
          error
        );
        setLoading(false);
      });
  }, [aValue, includeExclude]);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleClearDate = () => {
    setSelectedDate(null);
  };

  const handleModel = (modelId) => {
    setModeleValue(modelId);
    const modelMessage =
      modeleData.find((model) => model.id === modelId)?.contenu || "";
    setMessage(modelMessage);
  };

  const handleChangeInclude = () => {
    setIncludeExclude((prev) => (prev === "include" ? "exclude" : "include"));
  };

  const handleCostumModel = () => {
    openModal(
      "Gestion modèle",
      <ModelCourierModifiable
        setMessage={setMessage}
        closeModal={closeModal}
        setModeleValue={setModeleValue}
        setRefresh={setRefresh}
        refresh={refresh}
        handleModel={handleModel}
      />
    );
  };

  const handleConfirm = () => {
    setConfirmOpen(true);
  };

  const handleSend = () => {
    setConfirmOpen(false);

    const lstGroupesDest = aValue.join(",");
    const modelName =
      modeleData.find((model) => model.id === modeleValue)?.name || "";
    const idPersonsString = destinataireValue
      .map((obj) => obj.idPerson)
      .join(",");

    let stDateTimeFromD = null;
    if (selectedDate) {
      stDateTimeFromD = stDateTimeFromDate(selectedDate);
    }

    const formData = new FormData();
    formData.append("lstGroupesDest", lstGroupesDest);
    formData.append("vModele", modelName);
    formData.append("vMessage", message);
    formData.append("vDest", idPersonsString);
    formData.append("vSheduleMessage", stDateTimeFromD);
    formData.append("vMessageOrig", message);
    formData.append("vReply", "");
    formData.append("includeExclude", includeExclude);
    formData.append("vTextDest", lstGroupesDest);
    formData.append("vRepondreA", repondreA);
    //formData.append;
    formData.append(
      "vUtiliserMonEmail",
      repondreA === manifEmail ? false : true
    );

    if (
      listGroupeDestinataireText === "" ||
      listGroupeDestinataireText.length < 1
    ) {
      formData.append(
        "listGroupeDestinataireText",
        destinataireValue.map((dest) => dest.text)
      );
    } else {
      formData.append("listGroupeDestinataireText", listGroupeDestinataireText);
    }

    if (selectedFiles) {
      selectedFiles.forEach((file) => {
        formData.append("fileid", file);
      });
    }

    const urlEmail = selectedDate ? "/email/sheduler" : "/email/envoyer";

    rest
      .post(urlEmail, formData)
      .then((response) => {
        setSnack({
          message: selectedDate
            ? "Email programmé avec succès"
            : "Email envoyé avec succès",
          show: true,
          severity: "success",
        });
        // Reset form
        setAValue([]);
        setListeGroupeDestinataireText([]);
        setModeleValue(0);
        setDestinataireValue([]);
        setMessage("");
        setSelectedDate(null);
        //setSelectedFiles([]);

        setRefresh((prev) => !prev);
      })
      .catch((error) => {
        console.error("Une erreur s'est produite lors envoyer mail :", error);
      });
  };

  if (
    !groupesDestinataires ||
    !Array.isArray(groupesDestinataires.Destinataires)
  ) {
    return null;
  }

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    const totalSize = files.reduce((acc, file) => acc + file.size, 0);

    if (totalSize > 5242880) {
      // 5 Mo en octets
      setError("La taille totale des fichiers ne doit pas dépasser 5 Mo.");
      setSelectedFiles([]);
    } else {
      setError("");
      setSelectedFiles(files);
    }
  };

  return (
    <>
      <LoadingIndicator open={loading} />
      <MySnackbar params={snack} />
      <div
        container
        style={{
          maxWidth: !openSidebar ? "calc(100vw - 0px)" : "calc(100vw - 300px)",
        }}
      >
        <Container
          maxWidth="xl"
          style={{
            marginTop: 10,
            marginBottom: 20,
          }}
          elevation={5}
        >
          <Grid item xs={12} className={classes.headerContainer}>
            <MailOutlineIcon className={classes.headerIcon} />
            <Typography variant="h5" className={classes.headerText}>
              Contacter les bénévoles
            </Typography>
          </Grid>

          <Paper style={{ padding: 20 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} style={{ position: "relative" }}>
                <GroupSelect
                  aValue={aValue}
                  setAValue={setAValue}
                  setListeGroupeDestinataireText={
                    setListeGroupeDestinataireText
                  }
                  includeExclude={includeExclude}
                  handleChangeInclude={handleChangeInclude}
                  groupesDestinataires={groupesDestinataires}
                />
              </Grid>

              <Grid item xs={12}>
                <FilteredSelect
                  destinataires={destinataires}
                  selectedDestByGroups={selectedDestByGroups}
                  destinataireValue={destinataireValue}
                  setDestinataireValue={setDestinataireValue}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl variant="outlined" fullWidth>
                  <InputLabel htmlFor="modele-select">Modèle</InputLabel>
                  <Select
                    fullWidth
                    value={modeleValue}
                    onChange={(e) => handleModel(e.target.value)}
                    input={
                      <OutlinedInput
                        label="Modèle"
                        endAdornment={
                          (currentUser?.User.User_Administrator === true ||
                            currentUser?.User.User_Chef === true) && (
                            <InputAdornment position="end">
                              <Tooltip title="Configurer un modèle" arrow>
                                <IconButton onClick={handleCostumModel}>
                                  <SettingsIcon />
                                </IconButton>
                              </Tooltip>
                            </InputAdornment>
                          )
                        }
                      />
                    }
                  >
                    <MenuItem value={0}>
                      <em>Sélectionnez un modèle</em>
                    </MenuItem>

                    {modeleData &&
                      modeleData.map((model) => (
                        <MenuItem key={model.id} value={model.id}>
                          <Box
                            display="flex"
                            alignItems="center"
                            width="100%"
                            justifyContent="space-between"
                          >
                            <span>{model.name}</span>
                            <Box display="flex" alignItems="center">
                              {model.creator && (
                                <Tooltip title="Votre modèle" arrow>
                                  <AccountCircleIcon
                                    style={{ color: "#346185", marginRight: 8 }}
                                  />
                                </Tooltip>
                              )}
                              {model.shared && (
                                <Tooltip title="Partagé" arrow>
                                  <ShareIcon
                                    style={{ color: "#346185", marginRight: 8 }}
                                  />
                                </Tooltip>
                              )}
                            </Box>
                          </Box>
                        </MenuItem>
                      ))}
                  </Select>
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl variant="outlined" fullWidth>
                  <DateTimePicker
                    label="Planificateur d'envoi"
                    fullWidth
                    inputVariant="outlined"
                    variant="outlined"
                    format="dd/MM/yyyy HH:mm"
                    value={selectedDate}
                    onChange={handleDateChange}
                    minDate={new Date()}
                    localeutils={frLocale}
                    InputProps={{
                      endAdornment: selectedDate ? (
                        <InputAdornment position="end">
                          <Tooltip title="Supprimer la date" arrow>
                            <IconButton
                              aria-label="Clear date"
                              onClick={(e) => {
                                e.stopPropagation();
                                handleClearDate();
                              }}
                              edge="end"
                            >
                              <ClearIcon />
                            </IconButton>
                          </Tooltip>
                        </InputAdornment>
                      ) : null,
                    }}
                  />
                </FormControl>
              </Grid>

              <Grid item xs={12} md={4}>
                <FormControl
                  variant="outlined"
                  className={classes.formControl}
                  fullWidth
                >
                  <InputLabel>Répondre à</InputLabel>
                  <Select
                    value={repondreA}
                    onChange={(e) => setRepondreA(e.target.value)}
                    label="Répondre à"
                  >
                    <MenuItem value={manifEmail}>{manifEmail}</MenuItem>
                    <MenuItem value={userEmail}>{userEmail}</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Typography variant="h6">Message :</Typography>
              </Grid>

              <Grid item xs={12}>
                <CustomEditorDropdown
                  message={message}
                  setMessage={setMessage}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  variant="outlined"
                  fullWidth
                  label="Sélectionner des fichiers"
                  InputLabelProps={{ shrink: true }}
                  inputProps={{
                    id: "file-upload",
                    type: "file",
                    multiple: true,
                    onChange: handleFileChange,
                  }}
                  error={Boolean(error)}
                  helperText={error}
                  InputProps={
                    selectedFiles &&
                    selectedFiles.length > 0 && {
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            onClick={() => {
                              setSelectedFiles([]);
                              setError("");
                              document.getElementById("file-upload").value = "";
                            }}
                          >
                            <ClearIcon />
                          </IconButton>
                        </InputAdornment>
                      ),
                    }
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <ButtonStyled
                  onClick={handleConfirm}
                  variant="contained"
                  color="successDarkBtn"
                  style={{ float: "right" }}
                  disabled={error ? true : false}
                >
                  Suivant
                </ButtonStyled>
              </Grid>
            </Grid>
          </Paper>
        </Container>

        <Container maxWidth="xl" style={{ marginBottom: 20 }} elevation={5}>
          <SchedulerTable refreshParent={refresh} />
        </Container>

        <Container maxWidth="xl" style={{ marginBottom: 20 }} elevation={5}>
          <HistoriqueTable refreshParent={refresh} />
        </Container>

        <ConfirmationModal
          open={confirmOpen}
          handleClose={() => setConfirmOpen(false)}
          handleConfirm={handleSend}
          message={message}
        />
      </div>
    </>
  );
};

const ContactBenevole = () => {
  return (
    <>
      <MuiPickersUtilsProvider utils={DateFnsUtils} locale={frLocale}>
        <FormContactBene />
      </MuiPickersUtilsProvider>
    </>
  );
};

export default ContactBenevole;
